export class Schedule {
  constructor(
    public projectId: string,
    public masterTaskName: string,
    public percentageCompleted: string,
    public baselineStartDate: string,
    public baselineFinishDate: string,
    public startDate: string,
    public finishDate: string,
    public actualStartDate: string,
    public actualFinishDate: string,
  ) {}
}
